import { observable, action } from 'mobx'
import { cart, cartItem } from './types'

class Store {
  @observable public active = false
  @observable public items: Array<cartItem> = []
  @observable public updating = false
  @observable public menu: string = 'black'
  @observable public observer = <IntersectionObserver | null>null  

  constructor() {
  }

  @action toggle() {
    this.active = !this.active
  }

  @action changeMenu(color: string) {
    this.menu = color
  }

  @action add(item: cartItem) {
    const index = this.items.findIndex(thisItem => thisItem.id === item.id)

    if (index > -1) {
      this.items[index].quantity = this.items[index].quantity + 1
    } else {
      this.items.push(item)
    }
  }

  @action remove(item: cartItem) {
    const index = this.items.findIndex(thisItem => thisItem.id === item.id)

    if (index > -1) {
      this.items = this.items.slice(index, 1)
    }
  }

  @action populate(cart: cart) {
    this.items = cart.items
  }

  @action initObserver(observer: IntersectionObserver) {
    this.observer = observer
  }
}

export const store = new Store()

